module.exports = require('./$.hide');


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/core-js/library/modules/$.redefine.js
 ** module id = 18
 ** module chunks = 2
 **/